<template>
  <div class="container-content">
    <div class="home-container">
    </div>
    <div class="body-container">
      <div class="body-content">
        <span class="location">您现在所在的位置：认证认可>{{curr}}</span>
        <span class="search" style="position:relative">
          <input
            placeholder="认证认可搜索"
            v-model="searchValue"
          />
          <img  @click="toCommon({name:'认证认可',level:'认证机构'})"
                style="width:20px;height:20px;position:absolute;top:20px;right:250px"
                src="../../assets/images/search.svg"
          />
        </span>
      </div>
      <div class="content">
        <div class="content-left">
          <div class="headline">
            <div class="img">
              <img src="../../assets/images/icon/icon-rzrk.png">
            </div>
            <div class="word">
              <span class="character">认证认可</span>
              <span class="english">Accreditation</span>
            </div>
          </div>
          <div class="frame">
            <div class="industry" :class="{active: curr==='基础查询事项'}" @click="switchPage('基础查询事项')">基础查询事项</div>
            <div class="industry" :class="{active: curr==='资质审批事项'}" @click="switchPage('资质审批事项')">资质审批事项</div>
            <div class="industry" :class="{active: curr==='产品认证'}" @click="switchPage('产品认证')">产品认证</div>
            <div class="industry" :class="{active: curr==='服务认证'}" @click="switchPage('服务认证')">服务认证</div>
            <div class="industry" :class="{active: curr==='体系认证'}" @click="switchPage('体系认证')">体系认证</div>
          </div>
        </div><!--
        --><div class="content-right">
        <div class="details-list" v-if="curr=='基础查询事项'">
          <div class="list-head">
            <div class="state-head">{{curr}}</div>
            <div class="english-head">Basic item query</div>
          </div>
          <ul>
            <li><a target="_blank" href="http://www.cnca.gov.cn/xxgk/hydt/201910/t20191018_57395.shtml">市场监管总局启动全国检验检测机构资质认定评审员网上能力测试</a></li>
            <li><a target="_blank" href="http://www.cnca.gov.cn/xxgk/hydt/201910/t20191018_57394.shtml">全球食品安全倡议继续承认我国HACCP认证</a></li>
            <li><a target="_blank" href="http://www.cnca.gov.cn/xxgk/hydt/201910/t20191017_57386.shtml">我国服务认证 发展进入快车道</a></li>
            <li><a target="_blank" href="http://www.cnca.gov.cn/xxgk/hydt/201907/t20190723_57314.shtml">2019年强制性产品认证获证产品认证有效性抽查工作部署和研讨会议在成都召开</a></li>
            <li><a target="_blank" href="http://www.cnca.gov.cn/xxgk/hydt/201907/t20190708_57299.shtml">ISO发布世界上第一项针对品牌评价的国际标准</a></li>
            <li><a target="_blank" href="http://www.cnca.gov.cn/xxgk/ggxx/2019/201910/t20191017_57387.shtml">市场监管总局关于调整完善强制性产品认证目录和实施要求的公告</a></li>
            <li><a target="_blank" href="http://www.cnca.gov.cn/xxgk/zxtz/2019/201910/t20191008_57382.shtml">认监委关于组织申报2019年认证认可行业标准制修订项目的通知</a></li>
            <li><a target="_blank" href="http://www.cnca.gov.cn/xxgk/tpxw/201910/t20191027_57410.shtml">市场监管总局认证监管司调研上海绿地贸易港</a></li>
            <li><a target="_blank" href="http://www.cnca.gov.cn/xxgk/tpxw/201906/t20190621_57291.shtml">2019年认证监管工作研讨会在浙江绍兴召开</a></li>
            <li><a target="_blank" href="http://www.cnca.gov.cn/xxgk/jgdt/201906/t20190628_57294.shtml">北京市市场监督管理局召开世界认可日宣传大会</a></li>
          </ul>
        </div>
        <div class="details-list" v-if="curr=='资质审批事项'">
          <div class="list-head">
            <div class="state-head">{{curr}}</div>
            <div class="english-head">Qualification approval items</div>
          </div>
          <ul>
            <li><a target="_blank" href="http://www.cnacm.org.cn/display.php?id=767">国家认监委发布统一绿色产品认证标识</a></li>
            <li><a target="_blank" href="http://www.cnacm.org.cn/display.php?id=613">中国绿色食品发展中心关于新增绿色食品检测机构的通知</a></li>
            <li><a target="_blank" href="http://www.cnacm.org.cn/display.php?id=604">国家认监委关于认证规则备案的公告</a></li>
            <li><a target="_blank" href="http://www.cnacm.org.cn/display.php?id=587">国家认监委关于进一步明确检验检测机构资质认定工作有关问题的通知</a></li>
            <li><a target="_blank" href="http://www.cnacm.org.cn/display.php?id=578">认证技术规范管理办法</a></li>
            <li><a target="_blank" href="http://www.cnacm.org.cn/display.php?id=509">GB/T CCA9002企业信用评价标准（国家行业标准）</a></li>
            <li><a target="_blank" href="http://www.cnacm.org.cn/display.php?id=211">《消防产品监督管理规定》（公安部，工商总局，质检总局令第122号）</a></li>
            <li><a target="_blank" href="http://www.cnacm.org.cn/display.php?id=209">《认证证书和认证标志管理办法》（总局令第162号）</a></li>
          </ul>
        </div>
        <div class="details-list" v-if="curr=='产品认证'">
          <div class="list-head">
            <div class="state-head">{{curr}}</div>
            <div class="english-head">Product certification</div>
          </div>
          <ul>
            <li><a target="_blank" href="http://cx.cnca.cn/CertECloud/institutionBody/authenticetionList">可通过机构批准号，机构名称、认证领域、行政区划进行查询。</a></li>
          </ul>
        </div>
        <div class="details-list" v-if="curr=='服务认证'">
          <div class="list-head">
            <div class="state-head">{{curr}}</div>
            <div class="english-head">Service certification</div>
          </div>
          <ul>
            <li><a target="_blank" href="http://cx.cnca.cn/CertECloud/institutionBody/authenticetionList">可通过机构批准号，机构名称、认证领域、行政区划进行查询。</a></li>
          </ul>
        </div>
        <div class="details-list" v-if="curr=='体系认证'">
          <div class="list-head">
            <div class="state-head">{{curr}}</div>
            <div class="english-head">System certification</div>
          </div>
          <ul>
            <li><a target="_blank" href="http://cx.cnca.cn/CertECloud/institutionBody/authenticetionList">可通过机构批准号，机构名称、认证领域、行政区划进行查询。</a></li>
          </ul>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      curr: '基础查询事项',
      searchValue: ''
    }
  },
  created () {
    if (this.$route.query.curr) {
      this.curr = this.$route.query.curr;
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    toCommon (obj) {
      this.$store.commit('saveSearchInputValue', this.searchValue);
      this.$store.commit('saveNormalList', [])
      localStorage.setItem('filterValue', obj.name)
      this.$store.commit('saveFilterValue')
      this.$store.commit('saveIsHot', false)
      this.$store.commit('saveIsTopNav', false)
      this.$router.push({ path: '/commonList' })
      this.$store.commit('saveMultipleValue', obj.level)
      this.$store.commit('saveIsSliderNav', true)
    },
    switchPage (page) {
      this.curr = page;
    }
  }
};
</script>

<style lang="less" scoped>
  .container-content{
    width: 100%;
    // max-width: 1920px;
    .home-container{
      position: relative;
      height: 343.8px;
      width: 100%;
      background-size: 100%;
      background-position: center;
      background-image:url("../../assets/images/certification.png");
      background-repeat: no-repeat;
    }
    .body-container{
      width:  @body-width;
      margin: 0 auto;
      .body-content{
        width: @body-width;
        line-height: 60px;
        background:#f5f5f5;
        margin: 30px auto 20px auto;
        padding-left: 24px;
        .search{
          input::-webkit-input-placeholder {
            padding-left: 40px;
            opacity: 0.5;
          }
          input{
            width:250px;height:38px;padding-left:30px;border:1px solid @color-base
          }
          padding-right:26px;
          float:right;
          color:#808080;
          font-size:14px;
          font-weight:400;
          cursor:pointer
        }
        .location{
          font-size:14px;
          font-weight:400;
          color:rgba(0,0,0,0.65);
        }
      }
      .content{
        width:  @body-width;
        margin: 0 auto;
        padding-bottom: 120px;
        .content-left{
          display: inline-block;
          width: 244px;
          height: 464px;
          .headline{
            padding: 10px 30px;
            width:244px;
            height:64px;
            background-color: @color-base ;
            .img{
              vertical-align:middle;
              display: inline-block;
              margin-bottom: 30px;
              margin-right: 5px;
            }
            .word{
              display: inline-block;
              .character{
                display: block;
                font-size:18px;
                font-weight:500;
                color: #f5f5f5;
              }
              .english{
                font-size:12px;
                font-weight:400;
                color:rgba(255,255,255,0.4);
              }
            }
          }
          .frame{
            width:220px;
            height:400px;
            padding: 20px 24px;
            background-color: #f5f5f5;
            .state{
              padding-left: 14px;
              width:220px;
              line-height:36px;
              background-image: url("../../assets/images/icon/bj.svg");
              font-size:16px;
              font-weight:500;
              color:#f5f5f5;
            }
            .industry{
              cursor: pointer;
              padding-left: 14px;
              width:220px;
              line-height:36px;
              font-size:16px;
              font-weight:400;
              color:rgba(0,0,0,0.65);
            }
            .active {
              color:#f5f5f5;
              background-image: url("../../assets/images/icon/bj.svg");
            }
          }
        }
        .content-right{
          padding:24px 0 0 30px;
          vertical-align:top;
          display: inline-block;
          width: 954px;
          min-height: 464px;
          border: 1px solid rgba(0, 0, 0, .1);
          margin-left: -1px;
          .details-list{
            .list-head{
              height: 40px;
              border-bottom: 1px solid rgba(0,0,0,0.1);
              .state-head{
                display: inline-block;
                line-height: 18px;
                padding-right: 12px;
                font-size:18px;
                font-weight:500;
                color:@color-base;
                border-right: 1px solid #D8D8D8;
              }
              .english-head{
                margin-left: 12px;
                display: inline-block;
                font-size:16px;
                font-weight:400;
                color:rgba(102,181,255,0.65);
              }
            }
            li:before {
        content: "\2022"; //圆点
        color: rgba(0, 0, 0, 0.25); //颜色
        font-size: 16px;
        padding-right: 8px; //大小
      }
            ul li{
              color: rgba(0,0,0,0.25);
              width:896px;
              line-height:54px;
              border-bottom: 1px solid rgba(0,0,0,0.1);
              a{
                font-size:14px;
                font-weight:400;
                color:rgba(0,0,0,0.85);
              }
            }
            li:hover{
              cursor: pointer;
              color:@color-base;
              box-shadow:0 4px 6px 0 rgba(@color-base,0.1);
              border: none;
            }
            li:hover a{
              color: @color-base;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/certificaTion/certification.vue